import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import { AutoComplete } from 'antd';

const SearchDeviceComponent = (props) => {
  const dispatch = useDispatch();
  const { deviceType, callback } = props;
  const { searchDevices, namespace } = useSelector((state) => state);
  const [data, setData] = useState(searchDevices || []);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState('');

  useEffect(() => {
    setData(searchDevices || []);
    if (searchDevices && searchDevices.length > 0) {
      const results = searchDevices.map((item) => ({
        value: item.name,
        data: item,
        label: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <span>{item.name}</span>
          </div>
        ),
      }));

      setOptions(results);
    } else {
      setOptions([]);
    }
  }, [searchDevices]);

  const onSearch = (name) => {
    if (!name) return;
    const dataBody = {
      name,
      deviceType,
      namespace,
    };
    const dataObj = {
      appServiceType: SERVICE.SEARCH_DEVICE_BY_NAME,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  const handleOnSearch = (value) => {
    setValue(value);
    if (value && value.length > 1) {
      onSearch(value);
    }
  };

  return (
    <AutoComplete
      style={{ width: '100%', fontSize: 16 }}
      dropdownMatchSelectWidth={'100%'}
      options={options}
      onSearch={handleOnSearch}
      onSelect={(value, option) => {
        if (callback) callback(option.data);
      }}
    >
      {props.children}
    </AutoComplete>
  );
};

export default SearchDeviceComponent;
